const userManagementFil = {
    country: require('../../lang/fil/user_management/Country').default,
    state: require('../../lang/fil/user_management/State').default,
    city: require('../../lang/fil/user_management/City').default,
    menu: require('../../lang/fil/user_management/MainMenu').default,
    subMenu: require('../../lang/fil/user_management/SubMenu').default,
    action: require('../../lang/fil/user_management/Action').default,
    empPermission: require('../../lang/fil/user_management/EmployeePermission').default,
    businessArea: require('../../lang/fil/user_management/BusinessArea').default,
    entity: require('../../lang/fil/user_management/Entity').default,
    entityPermission: require('../../lang/fil/user_management/EntityPermission').default,
    hq: require('../../lang/fil/user_management/HeadQuarter').default,
    industry: require('../../lang/fil/user_management/Industry').default,
    warehouse: require('../../lang/fil/user_management/WareHouse').default,
    year: require('../../lang/fil/user_management/Year').default,
};

export default userManagementFil;